import React, { useEffect, useRef } from 'react';

// Google AdSense placeholder client id — replace with real 'ca-pub-...' when available.
const ADSENSE_CLIENT = 'ca-pub-XXXXXXXXXXXXXX';

const AdSlot = ({ slotId = '1234567890', className = '', style }) => {
  const insRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.warn('[AdSlot] adsbygoogle push failed (expected in dev):', e?.message);
    }
  }, []);

  return (
    <div className={`w-full ${className}`} style={style}>
      <div className="text-[10px] uppercase tracking-widest text-white/40 mb-2">Advertisement</div>
      <ins
        ref={insRef}
        className="adsbygoogle block"
        style={{ display: 'block', minHeight: 90, background: 'rgba(255,255,255,0.03)', borderRadius: 6 }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSlot;
